// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__6s5QX","checkbox":"SuperCheckbox_checkbox__AoQ7a","spanClassName":"SuperCheckbox_spanClassName__D2m9g"};